const USER_TYPES = {
  ADM: { key: 'ADM', name: 'Administrador' },
  DOC: { key: 'DOC', name: 'Médico' },
  EMP: { key: 'EMP', name: 'Responsável Empresa' },
  PAT: { key: 'PAT', name: 'Paciente' },
  TEC: { key: 'TEC', name: 'Técnico' },
};

export default USER_TYPES;
